<div class="col-sm-2 service-request-filter">
    <div class="service-request-filter_view-part" (click)="showDropdown = !showDropdown">Filter</div>
    <div class="service-request-filter_dropdown" [hidden]="!showDropdown">
        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="openCheckbox" #openCheckbox (change)="changeFilter()">
                <label for="openCheckbox"><svg-checked></svg-checked></label>
                <span>Open</span>
            </label>
        </div>
        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="inProgressCheckbox" #inProgressCheckbox (change)="changeFilter()">
                <label for="inProgressCheckbox"><svg-checked></svg-checked></label>
                <span>In Progress</span>
            </label>
        </div>
        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="onHoldCheckbox" #onHoldCheckbox (change)="changeFilter()">
                <label for="onHoldCheckbox"><svg-checked></svg-checked></label>
                <span>On Hold</span>
            </label>
        </div>
        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="closedCheckbox" #closedCheckbox (change)="changeFilter()">
                <label for="closedCheckbox"><svg-checked></svg-checked></label>
                <span>Closed</span>
            </label>
        </div>
        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="cancelledCheckbox" #cancelledCheckbox (change)="changeFilter()">
                <label for="cancelledCheckbox"><svg-checked></svg-checked></label>
                <span>Cancelled</span>
            </label>
        </div>
        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="archivedCheckbox" #archivedCheckbox (change)="changeFilter()">
                <label for="archivedCheckbox"><svg-checked></svg-checked></label>
                <span>Archived</span>
            </label>
        </div>

        <hr>

        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="urgentCheckbox" #urgentCheckbox (change)="changeFilter()">
                <label for="urgentCheckbox"><svg-checked></svg-checked></label>
                <span>Urgent</span>
            </label>
        </div>
        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="highCheckbox" #highCheckbox (change)="changeFilter()">
                <label for="highCheckbox"><svg-checked></svg-checked></label>
                <span>High</span>
            </label>
        </div>
        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="mediumCheckbox" #mediumCheckbox (change)="changeFilter()">
                <label for="mediumCheckbox"><svg-checked></svg-checked></label>
                <span>Medium</span>
            </label>
        </div>
        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="lowCheckbox" #lowCheckbox (change)="changeFilter()">
                <label for="lowCheckbox"><svg-checked></svg-checked></label>
                <span>Low</span>
            </label>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/service-request-filter/service-request-filter.component.html